// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__AUvGO","formControl":"addForm_formControl__MBRG2","list":"addForm_list__BSV1w","btnWrpper":"addForm_btnWrpper__bfnlh"};